const getPublishedSiteData = (rootState) => rootState.site.publishedSiteData;

export default getPublishedSiteData;
